if (!window.susumuSizeConfirmationBound) {
  window.susumuSizeConfirmationBound = true;
  document.documentElement.dataset.susumuSizeConfirmationBound = "true";

  // Shopify selects a variant for stock and price; the shopper confirms the size.
  const markSizeChosen = (sizeInput) => {
    if (!sizeInput || sizeInput.disabled) return;
    const picker = sizeInput.closest(".variant-picker__option--size")?.closest("variant-picker");
    if (!picker) return;
    const productForm = document.getElementById(picker?.getAttribute("form-id"))?.closest("product-form");
    if (!productForm) return;
    productForm.dataset.susumuSizeChosen = "true";
    const warning = picker.querySelector("[data-susumu-size-warning]");
    if (warning) warning.hidden = true;
  };

  document.addEventListener("click", (event) => {
    const sizeValues = event.target.closest?.(".variant-picker__option--size .variant-picker__option-values");
    const sizeLabel = event.target.closest?.("label[for]");
    if (!sizeValues || !sizeLabel) return;
    markSizeChosen(document.getElementById(sizeLabel.htmlFor));
  }, true);

  document.addEventListener("change", (event) => {
    if (event.target.matches?.(".variant-picker__option--size input[type='radio']")) {
      markSizeChosen(event.target);
    }
  }, true);

  document.addEventListener("submit", (event) => {
    const productForm = event.target.closest?.("product-form[data-susumu-require-size]");
    if (!productForm || productForm.dataset.susumuSizeChosen === "true") return;
    const formId = event.target.getAttribute("id");
    const picker = formId && document.querySelector(`variant-picker[form-id="${CSS.escape(formId)}"]`);
    const warning = picker?.querySelector("[data-susumu-size-warning]");
    if (!warning) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    warning.hidden = false;
    warning.scrollIntoView({ block: "center", behavior: "smooth" });
  }, true);
}
